// Core
import { Suspense } from 'react';
// Components
import { InputSkeleton } from '../Skeleton';
import lazyWithPreload from 'helpers/lazyWithPreload';
import type { IPhoneInputProps } from './PhoneInputField';

// react-phone-number-input brings libphonenumber (47 KB gzip). It sits in forms that open in a modal,
// so its code is fetched when the field first renders, not with every page that has such a modal;
// `preloadPhoneInput` lets the app fetch it in the background.
const PhoneInputField = lazyWithPreload(() => import('./PhoneInputField'));

export const preloadPhoneInput = PhoneInputField.preload;

const PhoneInput = (props: IPhoneInputProps) => (
  <Suspense fallback={<InputSkeleton size={props.size} />}>
    <PhoneInputField {...props} />
  </Suspense>
);

export default PhoneInput;
